import { useState } from "react";
import { TdsButton, TdsTypography, TdsIcon } from "@tds/react";
import EmwAutocomplete from "../../common/EmwAutocomplete";
import { WORKER_API_ENDPOINT } from "../../constants";
import { calculateAutocompleteSugestionForEmployee } from "../../common/utils";

const getEmployeeLabel = (option) => {
  const emp = option?.object || option;
  if (!emp) return "";
  const name = `${emp.firstName ?? ""} ${emp.lastName ?? ""}`.trim();
  return emp.tgi ? `${name} ${emp.tgi}` : name;
};

export default function ImpersonatingSection({
  layoutType,
  step,
  isAdminOrSU,
  setEmployee,
}) {
  const [value, setValue] = useState({});

  const handleOwnerSelect = (selectedOption) => {
    const employeeObj = selectedOption?.object ? selectedOption.object : {};
    setEmployee(employeeObj);
    setValue(employeeObj);
  };

  const stopImpersonation = () => {
    setEmployee({});
    setValue({});
  };

  const isImpersonating = Object.keys(value).length !== 0;

  const shouldShowImpersonateControls =
    layoutType === "desktop" && step === 1 && isAdminOrSU && !isImpersonating;

  const shouldShowBanner =
    layoutType === "desktop" && isAdminOrSU && isImpersonating;

  return (
    <>
      {shouldShowImpersonateControls && (
        <div className="impersonate-header flex items-center pb-xs">
          <div className="flex pr-s">
            <TdsTypography fontSize={7}>Impersonate employee</TdsTypography>
          </div>
          <div className="flex" style={{ width: "40%" }}>
            <EmwAutocomplete
              value={value || []}
              placeHolder="Search employee"
              inputId="impersonate-input-search"
              additionalCSS={{
                width: "100%",
                flexShrink: 0,
                backgroundColor: "white",
                ".MuiInputBase-sizeSmall": {
                  borderRadius: "3px",
                  padding: 0,
                },
              }}
              autoFocus={false}
              calculateAutocompleteSugestion={
                calculateAutocompleteSugestionForEmployee
              }
              calculateAutocompleteLabel={getEmployeeLabel}
              onAutocompleteChange={handleOwnerSelect}
            />
          </div>
        </div>
      )}

      {shouldShowBanner && (
        <div className="pb-xs">
          <div className="impersonation-banner p-xs flex">
            <div className="impersonation-info">
              <div className="flex items-center">
                <TdsIcon icon="person" classes="mr-xs" />
                <TdsTypography classes="impersonation-title">
                  Currently impersonating
                </TdsTypography>
              </div>
              <TdsTypography classes="impersonation-name">
                {value.firstName} {value.lastName}
                {value.tgi && ` (${value.tgi})`}
              </TdsTypography>
            </div>
            {step === 1 && (
              <TdsButton
                variant="filled"
                classes="rounded"
                onClick={stopImpersonation}
              >
                Stop
              </TdsButton>
            )}
          </div>
        </div>
      )}
    </>
  );
}
